<div class="measure-wrapper">
  <div class="grid-x">

    <div class="cell small-8">
      @if(inputType === 'checkbox') {
        <mat-checkbox (change)="changeMeasure($event)" [value]="form.controls[formField].value" [checked]="form.controls[formField].value" color="primary">
          <span>{{ textPrefix + measureName | translate }}
            @if (windowPercentage) {
              {{windowPercentage}}&nbsp;{{ 'unit.percent' | translate }}
            }
          </span>
          @if(showBadge === true) {
            <span class="label" [innerHTML]="textPrefix + 'recommend' | translate"></span>
          }
        </mat-checkbox>
      }
      @else if(inputType === 'radio') {
        <mat-radio-group>
          <mat-radio-button [disabled]="isMeasureDistrictDisabled" [value]="value" (change)="changeMeasure($event)" [checked]="form.controls[formField].value === value" [name]="measure" color="primary">
            <span [innerHTML]="textPrefix + measureName | translate"></span>
            @if(showBadge === true) {
              <span class="label" [innerHTML]="textPrefix + 'recommend' | translate"></span>
            }
            @if(alert === true) {
              <span class="label alert" (click)="toggleShowText()" [innerHTML]="textPrefix + 'notrecommend' | translate"></span>
            }
          </mat-radio-button>
        </mat-radio-group>
      }
      @else if(inputType === 'switch') {
        <mat-slide-toggle color="primary" [checked]="form.controls[formField].value" (change)="changeMeasure($event)">
          <span [innerHTML]="textPrefix + measureName | translate"></span>
        </mat-slide-toggle>
      }
    </div>

    <div class="cell small-4">
      <div class="grid-x">
        <div class="cell small-12 medium-9 large-10 text-right saving-bar-wrapper">
          @if(saving !== null) {
            <span role="img" [attr.aria-label]="saving" [class.saving-bar]="saving != 0" [class.primary]="saving < 0 && savingUnit === 'kwh'"
               [class.green]="saving < 0 && savingUnit === 'co2'"
               [class.no-saving]="saving > 0" [style.width]="width"></span>
          }
          <strong>{{saving | number: savingUnit === 'co2'? '1.0-1' : '1.0-0'}}</strong>
        </div>
        <div class="cell small-12 medium-3 large-2 text-right">
          <button type="button" class="help-button" [attr.aria-expanded]="showText" [attr.aria-controls]="measureName + '-help'" [attr.aria-label]="'arialabel.toggle.help' | translate" (click)="toggleShowText()">
            <i class="icon-help-circle"
               [class.primary]="internalPortal && showBadge && (form.controls[formField].value === value || form.controls[formField].value === true)"
               [class.warning]="hint && ((inputType === 'radio' && form.controls[formField].value === value) || (inputType !== 'radio' && form.controls[formField].value === true))"
               [class.alert]="(alert === true && form.controls[formField].value === value) || isMeasureDistrictDisabled">
            </i>
          </button>
        </div>
      </div>
    </div>
  </div>
  @if(showText) {
    <div class="callout lighter-gray">
      <button type="button" class="close" [attr.aria-label]="'arialabel.close' | translate" (click)="toggleShowText()"><i class="icon-x"></i></button>
      <p [id]="measureName + '-help'" [innerHTML]="textPrefix + measureName + textPostfix + '.text' | translate"></p>
      @if(showBadge === true) {
        <p class="success" [innerHTML]="textPrefix + measureName + textPostfix + '.empfehlung' | translate"></p>
      }
      @if(hint === true) {
        <p [className]="isMeasureDistrictDisabled ? 'alert' : 'warning'" [innerHTML]="(textPrefix + measureName + textPostfix + '.hinweis.' + recommendReason) | translate"></p>
      }
      @if(alert === true) {
        <p class="alert" [innerHTML]="textPrefix + measureName + textPostfix + '.warnung' | translate"></p>
      }
    </div>
  }
</div>
